class SwiperWithPagination extends HTMLElement {    
    connectedCallback() {   
        this.swiper = this.querySelectorAll('swiper-container')
        
        this.swiper.forEach((swiper) => {
            const swiperParams = {
                pagination: {
                    formatFractionCurrent: (number) => String(number).padStart(2, '0'),
                    formatFractionTotal: (number) => String(number).padStart(2, '0')
                }
            };
    
            Object.assign(swiper, swiperParams)
            swiper.initialize()  
        })
    }
}

window.customElements.define('swiper-with-pagination', SwiperWithPagination)